import { render, staticRenderFns } from "./FormQuizzQuestions.vue?vue&type=template&id=b1938b50&scoped=true&"
import script from "./FormQuizzQuestions.vue?vue&type=script&lang=js&"
export * from "./FormQuizzQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FormQuizzQuestions.vue?vue&type=style&index=0&id=b1938b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1938b50",
  null
  
)

export default component.exports